<div class="termo_fidelidade_banner">
    <img src="assets/images/banner-regulamento-premmiar.png">
    <input type="checkbox" [(ngModel)]="aceite" style="position:absolute;left: 27px;top: 234px;">
    <a (click)="submitForm()" class="area-clicavel"></a>
</div>